"use client"

import { useState } from "react"
import { Link } from "react-router-dom"
import "./ContactPage.css"
import Logo from "../img/logo3.png"

const ContactPage = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  })

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitStatus, setSubmitStatus] = useState("")

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)

    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false)
      setSubmitStatus("success")
      setFormData({ name: "", email: "", subject: "", message: "" })

      // Clear success message after 3 seconds
      setTimeout(() => setSubmitStatus(""), 3000)
    }, 1000)
  }

  const handleEmailClick = () => {
    window.location.href = "mailto:Contact@yupluck.com"
  }

  const handlePhoneClick = () => {
    window.location.href = "tel:+919686414727"
  }

  return (
    <div className="contact-page">
      {/* Enhanced Modern Header */}
      <header className="yupluck-header-main">
        <div className="yupluck-header-container">
          <div className="yupluck-logo-wrapper">
            <Link to="/" className="yupluck-logo-link">
              <div className="yupluck-logo-image-container">
                <img src={Logo || "/placeholder.svg"} alt="Yupluck" className="yupluck-logo-image" />
              </div>
              <span className="yupluck-logo-text">Yupluck</span>
            </Link>
          </div>

          <nav className="yupluck-desktop-navigation">
            <Link to="/" className="yupluck-nav-link">
              Home
            </Link>
            <Link to="/about" className="yupluck-nav-link">
              About
            </Link>
            <Link to="/contact" className="yupluck-nav-link active">
              Contact
            </Link>
          </nav>

          <div className="yupluck-header-actions">
            <Link to="/login" className="yupluck-login-button">
              Sign In
            </Link>
            <Link to="/register" className="yupluck-cta-button">
              Get Started Free
            </Link>
          </div>

          <button className="yupluck-mobile-menu-toggle" onClick={toggleMobileMenu}>
            <span className="yupluck-hamburger-line yupluck-hamburger-line-1"></span>
            <span className="yupluck-hamburger-line yupluck-hamburger-line-2"></span>
            <span className="yupluck-hamburger-line yupluck-hamburger-line-3"></span>
          </button>
        </div>

        {/* Enhanced Mobile Menu */}
        <div className={`yupluck-mobile-menu ${isMobileMenuOpen ? "yupluck-mobile-menu-active" : ""}`}>
          <div className="yupluck-mobile-menu-content">
            <nav className="yupluck-mobile-navigation">
              <Link to="/" className="yupluck-mobile-nav-item" onClick={toggleMobileMenu}>
                <span className="yupluck-mobile-nav-icon">🏠</span>
                <span className="yupluck-mobile-nav-text">Home</span>
              </Link>
              <Link to="/about" className="yupluck-mobile-nav-item" onClick={toggleMobileMenu}>
                <span className="yupluck-mobile-nav-icon">ℹ️</span>
                <span className="yupluck-mobile-nav-text">About</span>
              </Link>
              <Link to="/contact" className="yupluck-mobile-nav-item active" onClick={toggleMobileMenu}>
                <span className="yupluck-mobile-nav-icon">📞</span>
                <span className="yupluck-mobile-nav-text">Contact</span>
              </Link>
            </nav>
            <div className="yupluck-mobile-actions">
              <Link to="/login" className="yupluck-mobile-login-btn" onClick={toggleMobileMenu}>
                Sign In
              </Link>
              <Link to="/register" className="yupluck-mobile-cta-btn" onClick={toggleMobileMenu}>
                Get Started Free
              </Link>
            </div>
          </div>
        </div>
      </header>

      <div className="contact-container">
        {/* Header Section */}
        <div className="contact-header">
          <h1 className="contact-title">Get in Touch</h1>
          <p className="contact-subtitle">
            We'd love to hear from you. Send us a message and we'll respond as soon as possible.
          </p>
        </div>

        <div className="contact-content">
          {/* Contact Information */}
          <div className="contact-info">
            <h2 className="info-title">Contact Information</h2>

            <div className="contact-item">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <polyline
                    points="22,6 12,13 2,6"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="contact-details">
                <h3>Email</h3>
                <button className="contact-link email-link" onClick={handleEmailClick}>
                  Contact@yupluck.com
                </button>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7293C21.7209 20.9845 21.5573 21.2136 21.3521 21.4019C21.1468 21.5901 20.9046 21.7335 20.6407 21.8227C20.3769 21.9119 20.0974 21.9451 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77382 17.3147 6.72533 15.2662 5.18999 12.85C3.49997 10.2412 2.44824 7.27099 2.11999 4.18C2.095 3.90347 2.12787 3.62476 2.21649 3.36162C2.30512 3.09849 2.44756 2.85669 2.63476 2.65162C2.82196 2.44655 3.0498 2.28271 3.30379 2.17052C3.55777 2.05833 3.83233 2.00026 4.10999 2H7.10999C7.59531 1.99522 8.06579 2.16708 8.43376 2.48353C8.80173 2.79999 9.04207 3.23945 9.10999 3.72C9.23662 4.68007 9.47144 5.62273 9.80999 6.53C9.94454 6.88792 9.97366 7.27691 9.8939 7.65088C9.81415 8.02485 9.62886 8.36811 9.35999 8.64L8.08999 9.91C9.51355 12.4135 11.5865 14.4864 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9751 14.1858 16.3491 14.1061C16.7231 14.0263 17.1121 14.0555 17.47 14.19C18.3773 14.5286 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="contact-details">
                <h3>Phone</h3>
                <button className="contact-link phone-link" onClick={handlePhoneClick}>
                  +91 9686414727
                </button>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" />
                  <path
                    d="M12 21.7C17.3 17 20 13 20 10a8 8 0 1 0-16 0c0 3 2.7 7 8 11.7z"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                </svg>
              </div>
              <div className="contact-details">
                <h3>Office Hours</h3>
                <p className="office-hours">
                  Monday - Friday: 9:00 AM - 6:00 PM
                  <br />
                  Saturday: 10:00 AM - 4:00 PM
                  <br />
                  Sunday: Closed
                </p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-section">
            <h2 className="form-title">Send us a Message</h2>

            {submitStatus === "success" && (
              <div className="success-message">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Thank you! Your message has been sent successfully.
              </div>
            )}

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    placeholder="Your full name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    placeholder="your.email@example.com"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  required
                  placeholder="What is this regarding?"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  rows="6"
                  placeholder="Tell us more about your inquiry..."
                ></textarea>
              </div>

              <button type="submit" className="submit-button" disabled={isSubmitting}>
                {isSubmitting ? (
                  <>
                    <div className="spinner"></div>
                    Sending...
                  </>
                ) : (
                  <>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 3L22 12L2 21V16L16 12L2 8V3Z" fill="currentColor" />
                    </svg>
                    Send Message
                  </>
                )}
              </button>
            </form>
          </div>
        </div>

        {/* Additional Info */}
        <div className="additional-info">
          <div className="info-card">
            <h3>Quick Response</h3>
            <p>We typically respond to all inquiries within 24 hours during business days.</p>
          </div>
          <div className="info-card">
            <h3>Support</h3>
            <p>For urgent matters, please call us directly at +91 9686414727.</p>
          </div>
          <div className="info-card">
            <h3>Follow Us</h3>
            <p>Stay connected with us on social media for updates and news.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactPage
